module.exports = __webpack_public_path__ + "img/img-header.1f33070.png";